import { Flex, Result } from "antd";
import React from "react";

function ErrorDisplay() {
  return (
    <Flex align="center" justify="center">
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
      />
    </Flex>
  );
}

export default ErrorDisplay;
